import { OpenAPI as API } from '../services/general';

const removeTrailingSlashes = (url?: string): string => {
  if (!url?.length) return '';

  return url.replace(/\/+$/, '');
};

export * from './auth';
export * from './tasks';
export * from './context';
export * from './contacts';
export * from './campaigns';
export * from './webhooks';
export * from './prompts';
export * from './messages';
export * from './misc';

if (process.env.NODE_ENV === 'development') {
  API.BASE = '/api';
} else {
  API.BASE = removeTrailingSlashes(process.env.REACT_APP_API_URL);
}

export { API };
